import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {User} from '../models/user';
import {Farmer} from '../models/farmer';
import {AnalyticsModel} from '../models/analytics-model';
import {ConnectionService} from 'ng-connection-service';

@Injectable()
export class EchartsUtils {

  constructor(private http: HttpClient) {}

  chartPie() {
    return {
      'theme': 'macarons',
      'animation': true,
      'calculable': true,
      'animationEasing': 'elasticOut',
      'backgroundColor': '',
      'grid': {
        'left': 10,
          'right': 10,
          'bottom': 60,
          'containLabel': true
      },
      'tooltip' : {},
      'series': [
        {
          'id': '',
          'name': '',
          'data': [],
          'type': 'pie',
          'radius': [
            '40%',
            '50%'
          ],
          'center': [
            '50%',
            '50%'
          ],
          'label': {
            'normal': {
              'formatter': '{b}\n[{c}] {d}%'
            }
          }
        }
      ],
      'title': {
        'text': '',
          'subtext': '',
          'sublink': 'http://www.spidash.com',
          'left': 'center',
          'textStyle': {
          'fontSize': '12px'
        }
      },
      'legend': {
        // orient: 'vertical',
        // top: 'middle',
        'bottom': 10,
        'left': 'center',
        'data': []
      },
      'toolbox': {
        'show': true,
          'feature': {
          'dataView': {
            'show': false,
              'readOnly': false
          },
          'restore': {
            'show': false
          },
          'saveAsImage': {
            'show': true
          },
          'dataZoom': {
            'yAxisIndex': 'none'
          }
        }
      }
    };
  }

  barChart() {
    return {
      'theme': 'infographic',
      'animation': true,
      'calculable': true,
      'animationEasing': 'elasticOut',
      'backgroundColor': '',
      'grid': {
        'left': 10,
        'right': 10,
        'bottom': 60,
        'containLabel': true
      },
      'yAxis': [],
      'xAxis': [
        {
          'type': 'category',
          'boundaryGap': true,
          'data': []
        }
      ],
      'series': [],
      'legend': {
        'data': [],
        'bottom': 5,
        'itemGap': 6
      },
      'tooltip': {
        'trigger': 'axis',
        'axisPointer': {
          'type': 'cross',
          'label': {
            'backgroundColor': '#283b56'
          }
        }
      },
      'toolbox': {
        'show': true,
        'feature': {
          'dataView': {'show': true,'readOnly': false},
          'magicType': {'show': true,'type': [ 'line','bar']},
          'restore': {'show': true},
          'saveAsImage': { 'show': true},
          'dataZoom': {'yAxisIndex': true}
        }
      },
      'dataZoom': {
        'show': true,'start': 25,'end': 100,'bottom': 25
      }
    };
  }

  addSerie(opt: any){
    opt.series.push({
      'id': '',
      'name': '',
      'data': [],
      'type': 'bar',
      'label': {
        'normal': {
          'show': true,
          'position': 'top',
          'color': '#555555'
        }
      },
      'markPoint': {
        'data': [
          {
            'type': 'max',
            'symbole': 'circle',
            'name': 'Max',
            'symbol': 'pin'
          }
        ]
      }
    });
    return opt;
  }

  addYAxis(opt: any, name: string, position: string) {
    opt.yAxis.push({
      'name' : name,
      'type': 'value',
      position: position
    });
    return opt;
  }
}
